import { action } from 'satcheljs/lib/legacy';
import moveToStore from '../store/store';
/**
 * Sets the move to find text in the moveToFolderMenu store
 * @param findText the find text
 */
export default action('setMoveToFindText')(function setMoveToFindText(findText) {
    moveToStore.findText = findText;
});
//# sourceMappingURL=setMoveToFindText.js.map